import {
  useReducedMotion,
  useScroll,
  useTransform,
  type MotionValue,
} from "framer-motion";
import { useRef, type RefObject } from "react";

/** The element to attach and the motion value that scrolls it. */
interface ParallaxBinding {
  ref: RefObject<HTMLDivElement | null>;
  y: MotionValue<number>;
}
/**
 * Gentle scroll parallax — the element drifts `distance` px over its
 * journey through the viewport. Positive drifts down (feels heavier),
 * negative drifts up (feels lighter). Stilled under reduced motion.
 */
export function useParallax(distance: number): ParallaxBinding {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(
    scrollYProgress,
    [0, 1],
    reduce ? [0, 0] : [-distance, distance],
  );
  return { ref, y };
}
